import React, { useRef } from "react";

interface DateInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  readonly?: boolean;
}

const DateInput: React.FC<DateInputProps> = ({
  label,
  name,
  value,
  onChange,
  required,
  readonly = false,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openPicker = () => {
    // ✅ This must be triggered by a user gesture — here, click on the input
    if (inputRef.current && typeof inputRef.current.showPicker === "function") {

      if (!readonly){
        inputRef.current.showPicker();
      }
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium mb-1">{label} {required && <span className="text-red-500">*</span>}</label>
      <input
        ref={inputRef}
        type="date"
        name={name}
        value={value}
        onChange={onChange}
        onClick={openPicker} // ✅ attach directly to input
        required={required}
        readOnly={readonly}
        className="w-full border text-sm rounded px-3 py-2 cursor-pointer bg-white/90 text-black/90"
      />
    </div>
  );
};

export default DateInput;
